<header> </header>
<!-- begin main content -->
<div class="container" role="main" id="main-content">
    <div class="row">
        <div class="col-md-12 acl-container">
            <!-- left navigation -->
            <sideNav></sideNav>
            <!-- .end left navigation -->
            <div class="col-md-9">
                <h2>Older Adults - Health Promotion: Non Evidence-Based</h2>
                <p class="info mt-1">All fields are required</p>
                <div class="col-md-12 background-gray-lighter mb-1">
                    <h2>People Served</h2>
                </div>
                <!--THIS FIELD IS NOT APPLICABLE TO SINGLE PSA STATES-->
                <div class="col-md-9">
                    <label for="peopleServed" class="normal">Number of people served</label>
                </div>
                <div class="col-md-3 mb-1">
                    <acl-data-element-text [id]="'peopleServed'" [de]="_sectionModel.peopleServed"
                    (change)="updateTotals(); _sectionModel.peopleServed = validate(_sectionModel.peopleServed); onChange()">
                    </acl-data-element-text>
                    <acl-input-error [de]="_sectionModel.peopleServed"></acl-input-error>
                </div>

                <div class="col-md-12 background-gray-lighter mb-1">
                    <h2>Expenditures</h2>
                </div>

                <div class="col-md-9">
                    <label for="title3Expend" class="normal">Title III expenditure</label>
                </div>
                <div class="col-md-3 mb-1">
                    <acl-data-element-text [addOnOptions]="addOnOption" [id]="'title3Expend'" [de]="_sectionModel.title3Expend"
                    (change)="updateTotals(); _sectionModel.title3Expend = validate(_sectionModel.title3Expend); onChange()">
                    </acl-data-element-text>
                    <acl-input-error [de]="_sectionModel.title3Expend"></acl-input-error>
                </div>
                <div class="col-md-9">
                    <label for="otherStateExpend" class="normal">Other: State expenditure</label>
                </div>
                <div class="col-md-3 mb-1">
                    <acl-data-element-text [addOnOptions]="addOnOption" [id]="'otherStateExpend'" [de]="_sectionModel.otherStateExpend"
                    (change)="updateTotals(); _sectionModel.otherStateExpend = validate(_sectionModel.otherStateExpend); onChange()">
                    </acl-data-element-text>
                    <acl-input-error [de]="_sectionModel.otherStateExpend"></acl-input-error>
                </div>
                <div class="col-md-9">
                    <label for="nonStateExpend" class="normal">Other: Non-state expenditure</label>
                </div>
                <div class="col-md-3 mb-1">
                    <acl-data-element-text [addOnOptions]="addOnOption" [id]="'nonStateExpend'" [de]="_sectionModel.nonStateExpend"
                    (change)="updateTotals(); _sectionModel.nonStateExpend = validate(_sectionModel.nonStateExpend); onChange()">
                    </acl-data-element-text>
                    <acl-input-error [de]="_sectionModel.nonStateExpend"></acl-input-error>
                </div>
                <div class="col-md-9">
                    <label for="programIncome" class="normal">Program income expended</label>
                </div>
                <div class="col-md-3 mb-1">
                    <acl-data-element-text [addOnOptions]="addOnOption" [id]="'programIncome'" [de]="_sectionModel.programIncome"
                    (change)="updateTotals(); _sectionModel.programIncome = validate(_sectionModel.programIncome); onChange()">
                    </acl-data-element-text>
                    <acl-input-error [de]="_sectionModel.programIncome"></acl-input-error>
                </div>
                <div class="col-md-9">
                    <label for="totalExpend">Total expenditures</label>
                </div>
                <div class="col-md-3 mb-1">
                    <acl-data-element-text [addOnOptions]="addOnOption" [id]="'totalExpend'" [de]="_sectionModel.totalExpend"
                    [disabled]=true>
                    </acl-data-element-text>
                    <acl-input-error [de]="_sectionModel.totalExpend"></acl-input-error>
                </div>
                <div class="col-md-9"></div>
                <div class="col-md-3 mb-1"></div>
                <div class="col-md-9"></div>
                <div class="col-md-3 mb-1"></div>
                <div class="col-md-7">
                    <label for="expendPerUnit" class="normal">Total expenditure per person served</label>
                </div>
                <div class="col-md-5 mb-1">
                    <acl-data-element-text [addOnOptions]="createAddOnOptions('Per person served', addOnWidth)" [id]="'expendPerUnit'" [de]="_sectionModel.expendPerUnit"
                    [disabled]=true>
                    </acl-data-element-text>
                </div>

                <div class="col-md-12 row">
                    <div *ngIf="!validForm" class="has-error">
                      <p class="help-block">
                        There are errors on the page. You must fix the errors or clear the data in those fields in order to Save this form.
                      </p>
                    </div>
                    <button *ngIf="!validForm" data-target="#nextModal" data-toggle="modal" class="btn btn-primary mr-1">Next</button>
                    <button *ngIf="validForm" class="btn btn-primary mr-1" (click)="saveAndNext()">Save and next</button>
                    <button class="btn btn-default mr-1" (click)="save()" [disabled]="!validForm || !_sectionModel.isRequired">Save</button>
                    <a class="btn btn-link pull-right" [routerLink]="['/data-submissions/titleIIIOverview']">Return to Overview</a>
                  </div>
                  <div aria-labelledby="nextModalLabel" class="modal fade" id="nextModal" role="dialog" tabindex="-1"
                       style="display: none;">
                    <div class="modal-dialog" role="document">
                      <div class="modal-content">
                        <div class="modal-header">
                          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                            <span aria-hidden="true">×</span>
                          </button>
                          <h3 class="modal-title" id="nextModalLabel">
                            Recent changes on this page will not be saved
                          </h3>
                        </div>
                        <div class="modal-body">
                          <p>
                            There are errors on the page. You must fix the errors or clear the data in those fields in order to save this form.
                            <br />
                            <br />
                            You may select "Go back to form" to remove the errors or you may select "Proceed to next section" and all of new the data entered in the current section will be lost.
                          </p>
                        </div>
                        <div class="modal-footer">
                          <button class="btn btn-primary pull-left" data-dismiss="modal" type="button" href="#">Go back to form</button>
                          <button class="btn btn-primary pull-right" data-dismiss="modal" type="button" (click)="next()">Proceed to next section</button>
                        </div>
                      </div>
                    </div>
                  </div>
            </div>
            <!-- .end col-md-9 -->
        </div>
        <!-- .end acl-container (col-md-12) -->
    </div>
    <!-- .end row -->
</div>
<!-- ./container -->
